export const Environment = {
  discovery: 'https://api-nowotv.nowo.pt/api/v1/bootstrap/discover',
  system: 'SMARTTV_TIZEN',
  Oauth: {
    clientId: 'androme.tv-smarttv-tizen-1',
    redirectUri: 'https://nowotv.nowo.pt',
    uri: 'https://api-nowotv.nowo.pt/api/oauth/v1/auth/authorize',
    secret: '4NNSDOEeSXYMPzQPMtFK',
  },
  Castlabs: {
    // use web license key so we can watch video on dev websites
    licenseKey:
      'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiV2ViIiwidXJscyI6WyJodHRwczovL25vd290di5ub3dvLnB0Il0sImtpZCI6MTE3OX0.J0m7zON3KD6k7kkX7VDTg9A73y7t7VLItAuO4cj_Y4ill80yol0SU0oe1kBca4DcplzUXV9m7coLc0LrFz9vQx3y91AwoWftSdaQXeVt8efdL_zqqK0T5u_FHOlzXBEM-rBIK9Rtyyv6PyB4daZ5mlKhfhIEfLZ3dj1Rk12nr7-90o8QaqlHPZB0kUZQIGeB_YBDha1JeytTArQeu9v1zcbkFJU2G4vrr-kuqTaUec2PNWaRlrbSmUWL_tP7hraZxaM1mmoZDPhASOjYLmQaptOBq3ZGTs2bJyffOo3BrkfuZLguL4-qpq5goTT0NpkrqnQPR8Zr9y88TH9xE7I8Qw',
    drmMerchant: 'cabovisao',
    drmEnvironment: 'DRMtoday',
    drmStaging: false,
    defaultDrmProvider: 'PLAYREADY',
  },
  atv_ott_rights: ['LINEAR', 'NPVR'],
  atv_replay_ott_rights: ['REPLAY'],
};
